module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "invoice"
  }, [_c('dt', {
    staticClass: "title"
  }, [_vm._v("发票详情")]), _vm._v(" "), _vm._l((_vm.detailData), function(item) {
    return _c('dd', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.attrName))]), _vm._v(" "), ([5, 6].indexOf(item.fieldType) > -1) ? _c('div', {
      staticClass: "img-box"
    }, _vm._l((_vm.strToArr(item.value4Show)), function(url) {
      return _c('span', {
        staticClass: "img",
        on: {
          "click": function($event) {
            _vm.openLightbox(url)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": url,
          "height": "40",
          "width": "40"
        }
      })])
    })) : ([0].indexOf(item.fieldType) > -1 && item.multiValue) ? _c('span', {
      staticClass: "text"
    }, [(!item.multiValue.length) ? [_vm._v("\n          " + _vm._s('空') + "\n        ")] : _vm._l((item.multiValue), function(n, index) {
      return _c('p', {
        staticStyle: {
          "display": "inline-block"
        }
      }, [_c('a', {
        on: {
          "click": function($event) {
            _vm.openDetail(n.popModel, n.id)
          }
        }
      }, [_vm._v(_vm._s(n.value4Show))]), _vm._v(" "), (index !== item.multiValue.length - 1 && n.value4Show) ? _c('span', [_vm._v("、")]) : _vm._e()])
    })], 2) : (item.fieldType === 8) ? [(item.value4Show) ? _c('attachment-preview', {
      attrs: {
        "data": item.value4Show
      }
    }) : _vm._e()] : _c('span', {
      staticClass: "text"
    }, [(!item.popModel) ? [_vm._v("\n          " + _vm._s(item.value4Show || '空') + "\n        ")] : _c('a', {
      on: {
        "click": function($event) {
          _vm.openDetail(item.popModel, item.id)
        }
      }
    }, [_vm._v(_vm._s(item.value4Show))])], 2)], 2)
  }), _vm._v(" "), (_vm.relativeRedInvoices.length !== 0) ? _c('dt', {
    staticClass: "title red-title"
  }, [_vm._v("红冲发票")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.relativeRedInvoices), function(item) {
    return _c('div', {
      staticClass: "red-detail"
    }, [_c('dd', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v("红冲发票编号")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.openRedDetail(item.popModel, item.invoiceId)
        }
      }
    }, [_vm._v(_vm._s(item.sheetNo))])]), _vm._v(" "), _c('dd', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v("申请人")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.userName))])]), _vm._v(" "), _c('dd', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v("红冲开票金额")]), _vm._v(" "), _c('span', {
      staticClass: "text text-red"
    }, [_vm._v(_vm._s(item.totalMoney))])]), _vm._v(" "), _c('dd', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v("开票日期")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.invoiceDate))])]), _vm._v(" "), _c('dd', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v("备注")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.memo))])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79d4b969","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/invoice/invoice-basic-item.vue
// module id = 1308
// module chunks = 82